// src/components/UpcomingEvents/UpcomingEvents.jsx (ou ton chemin actuel)
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaCalendarAlt, FaMapMarkerAlt, FaInfoCircle } from "react-icons/fa";
import { getUpcomingEvents } from "./../../services/eventServices";
import Button from "./../../components/Button/Button";
import { useUser } from "./../Home/UserContext";
import { toAbsolutePhotoUrl } from "../../services/newsPhotoServices";

const FALLBACK = "/img/no-image.jpg";

const UpcomingEvents = () => {
  const [events, setEvents] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  const navigate = useNavigate();
  const { user } = useUser();

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const upcomingEvents = await getUpcomingEvents();
        const list = Array.isArray(upcomingEvents) ? upcomingEvents : [];
        setEvents(list.slice(0, 3)); // seulement 3 prochains
      } catch (error) {
        console.error("Failed to fetch events", error);
        setEvents([]);
      }
    };

    fetchEvents();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("fr-FR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  // URL absolue pour <img src=...>
  const toAbs = (url) => {
    const u = (url || "").trim();
    const abs = u ? toAbsolutePhotoUrl(u) : "";
    return abs || FALLBACK;
  };

  const onImgError = (e) => {
    if (e?.currentTarget) e.currentTarget.src = FALLBACK;
  };

  const handleMoreInfo = () => {
    if (!user) {
      alert("Veuillez vous connecter pour accéder à cette page.");
      navigate("/login");
      return;
    }
    navigate("/calendrier");
  };

  // Modale image
  const openModal = (imageUrl) => setSelectedImage(toAbs(imageUrl));
  const closeModal = () => setSelectedImage(null);

  return (
    <div className="container mx-auto">
      <h2 className="text-3xl font-extrabold mb-4 text-primary mx-auto text-center font-satoshi uppercase">
        Prochains Événements & Compétitions
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4">
        {events.map((event) => {
          const cover = toAbs(event?.photo_url);

          return (
            <div
              key={event.id}
              className="flex flex-col bg-slate-100 dark:bg-slate-500 shadow-md rounded-lg overflow-hidden"
            >
              <div className="flex-grow">
                <img
                  src={cover}
                  alt={event?.titre || "Événement"}
                  className="w-full h-64 object-cover cursor-pointer"
                  onClick={() => openModal(event?.photo_url)}
                  onError={onImgError}
                  loading="lazy"
                />

                <div className="p-4">
                  <h3 className="text-xl font-bold">{event?.titre}</h3>
                  <p className="text-sm">{event?.description}</p>

                  <div className="mt-2 text-sm">
                    <div className="flex items-center">
                      <FaCalendarAlt className="mr-2" />
                      {formatDate(event?.start)}
                      {event?.end ? ` - ${formatDate(event.end)}` : ""}
                    </div>

                    <div className="flex items-center mt-1">
                      <FaMapMarkerAlt className="mr-2" />
                      {event?.lieu_event || "Lieu à préciser"}
                    </div>
                  </div>
                </div>
              </div>

              {/* Bouton Plus d'infos (tu avais choisi de l'afficher uniquement si connecté) */}
              {user && (
                <Button
                  text="Plus d'infos"
                  onClick={handleMoreInfo}
                  icon={FaInfoCircle}
                  className="mt-4 gap-2 mx-4 mb-4"
                />
              )}
            </div>
          );
        })}
      </div>

      {/* Modale pour afficher l'image en grand */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <div className="relative" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage}
              alt="Agrandissement"
              className="max-w-full max-h-[70vh] rounded-lg"
              onError={onImgError}
            />
            <button
              className="absolute top-2 right-2 text-white text-2xl"
              onClick={closeModal}
              aria-label="Fermer"
              type="button"
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpcomingEvents;
